import axios from 'axios';
import { toast, loading, router } from '@/utils';

const loadingShow = loading.show;
const loadingHide = loading.hide;

// 30s 请求超时
axios.defaults.timeout = 30000;

// 响应拦截
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    loadingHide();
    if (error.message.indexOf('timeout') !== -1) {
      toast.fail('请求超时，请重试');
    }
    Promise.reject(error);
  }
);

const request = {
  // get 方法封装
  async get(url, params, config = {}) {
    let { headers, loading } = config;
    headers ??= { 'Content-Type': 'application/json' };
    if (loading) loadingShow();
    if (params && typeof params === 'object') params = { params }; // 参数为对象
    if (params && typeof params === 'string') { // 参数为字符串
      url += `/${params}`;
      params = null;
    }
    const res = params ? await axios.get(url, params, headers) : await axios.get(url); // 参数为对象 : 无参数/参数为字符串
    if (loading) loadingHide();
    return handlePromise(res, url);
  },
  // post 方法封装
  async post(url, params, config = {}) {
    let { headers, loading } = config;
    headers ??= { 'Content-Type': 'application/json' };
    if (loading) loadingShow();
    const res = await axios.post(url, params, headers);
    if (loading) loadingHide();
    return handlePromise(res, url);
  }
}

// 特殊接口 需要单独处理
const specialApi = [
  'api/registerVerifyCode',
  'api/addVisitorInfo',
];

const handlePromise = (res, url) => {
  if (!res) return new Promise((resolve, reject) => {
    toast.fail('发生错误，请稍后再试或联系运营');
    reject('发生错误，请稍后再试或联系运营');
  });
  const { code, msg } = res.data;
  return new Promise((resolve, reject) => {
    // 一般接口统一处理
    if (code === 200) {
      resolve(res.data);
    } else {
      // token过期
      if (code === 401) return router.tokenTimeout();
      // 单独特殊处理的接口
      for (let api of specialApi) if (api === url) return resolve(res.data);
      // 正常执行报错
      toast.fail(msg);
      reject(res.data);
    }
  });
}

export default request;